/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import React from 'react';
import { useLocation } from 'react-router-dom';

import { useFiche, FicheContainer } from '@mairistem/fiche';
import { Message } from '@mairistem/composants';

import type { TypeActe } from '@/types';

import ActeFiche from './ActeFiche';
import ActeFicheBar from './ActeFicheBar';
import FICHE_CONFIG from './ficheConfig';

interface ActeFicheContainerProps {
  /**
   * Type d'acte, passé par la route (`src/index.tsx`) plutôt que déduit de
   * l'URL : `baseUrlApp` diffère entre dev et prod, le segment à extraire n'est
   * donc pas à un index stable, et `FicheRouter` consomme déjà `useRouteMatch`.
   */
  typeActe: TypeActe;
}

const ActeFicheContainer = (props: ActeFicheContainerProps) => {
  const { typeActe } = props;

  const location = useLocation();
  // La modale « Ajouter une mention » peut être ouverte automatiquement en
  // arrivant sur la fiche, via le paramètre d'URL `mention` (ex. depuis la
  // modale « Saisir une mention » du dashboard) — même pattern que
  // `openSaisieEvenement` sur BlocCreation.tsx.
  const autoOpenAjoutMention =
    new URLSearchParams(location.search).get('mention') === '1';

  const config = FICHE_CONFIG[typeActe];

  // Appelé avant tout retour conditionnel : règle des hooks.
  const [service] = useFiche(config?.url ?? '');

  if (!config) {
    return (
      <Message
        error
        content={`Type d'acte non pris en charge par la fiche : ${typeActe}`}
      />
    );
  }

  return (
    <FicheContainer service={service} type="acte">
      {(p) => (
        <>
          <ActeFicheBar {...p} typeActe={typeActe} />
          <ActeFiche
            {...p}
            config={config}
            service={service}
            autoOpenAjoutMention={autoOpenAjoutMention}
          />
        </>
      )}
    </FicheContainer>
  );
};

export default ActeFicheContainer;
